import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Grid, makeStyles, Typography } from "@material-ui/core/";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useSelector } from "react-redux";
import Aux from "../../../hoc/Auxilliary";
import imageFirst from "../../../assests/ESC.png";
import imageSecound from "../../../assests/class.png";
import imageThird from "../../../assests/admission.png";
import localizedStrings from "../../../utils/localize";

const useStyle = makeStyles((theme) => ({
  rootGallery: {
    display: "flex",
    width: "100%",
    cursor: "pointer",
    justifyContent: "space-between",
    padding: "2rem 0",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
  galleryItems: {
    width: "31%",
    textAlign: "center",
    position: "relative",
    paddingBottom: "0.6rem",
    [theme.breakpoints.down("xs")]: {
      width: "90%",
    },
  },
  imageText: {
    display: "flex",
    width: "100%",
    background: "#000",
    opacity: 0.35,
    color: "#fff",
    textTransform: "uppercase",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "-1rem",
  },
}));

function Gallery(props) {
  const classes = useStyle(props);
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <Aux>
      <Grid container item xs={12} sm={12} className={classes.rootGallery}>
        <Grid item className={classes.galleryItems}>
          <Link to="/students/profile">
            <img src={imageFirst} width="30%" alt="iamge1" />
            <Typography component="div" className={classes.imageText}>
              <Typography>
                <span style={{ marginLeft: "6px", fontSize: "0.8rem" }}>
                  {localizedStrings.homePage.gallery.studentProfile}
                </span>
              </Typography>
              <ChevronRightIcon />
            </Typography>
          </Link>
        </Grid>
        <Grid item className={classes.galleryItems}>
          <Link to="/students/classes">
            <img src={imageSecound} width="30%" alt="iamge1" />
            <Typography component="div" className={classes.imageText}>
              <Typography>
                <span style={{ marginLeft: "6px", fontSize: "0.8rem" }}>
                  {localizedStrings.homePage.gallery.classes}
                </span>
              </Typography>
              <ChevronRightIcon />
            </Typography>
          </Link>
        </Grid>
        <Grid item className={classes.galleryItems}>
          <Link to="/prospective/application">
            <img src={imageThird} width="30%" alt="iamge1" />
            <Typography component="div" className={classes.imageText}>
              <Typography>
                <span style={{ marginLeft: "6px", fontSize: "0.8rem" }}>
                  {localizedStrings.homePage.gallery.admission}
                </span>
              </Typography>
              <ChevronRightIcon />
            </Typography>
          </Link>
        </Grid>
      </Grid>
    </Aux>
  );
}

export default Gallery;
